<template>
  <div>
    <Layout />
    <div class="container">
      <div class="breadcrumb-container">
        <router-link to="/asiento">Asientos</router-link>
        > Asiento {{ datoAsiento.numero }}
      </div>
      <div class="notification-area" v-for="(notificacion, index) in notificaciones" :key="index">
        <div class="notification-message"
          :class="{ 'is-success': notificacion.type === 'success', 'is-error': notificacion.type === 'error' }">
          {{ notificacion.message }}
        </div>
      </div>
    </div>
    <hr>
    <!-- Master -->
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <form>
          <div class="modal-body">
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="estadoAsiento" class="form-label">EstadoAsiento</label>
                </div>
                <div class="col-2">
                  <input type="text" class="form-control" id="estadoAsiento" name="estadoAsiento"
                    v-model="datoAsiento.estadoAsiento" style='text-transform:uppercase' disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="descripcion" class="form-label">Descripción</label>
                </div>
                <div class="col-10">
                  <textarea class="form-control" id="descripcion" name="descripcion" v-model="datoAsiento.descripcion"
                    style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>
            <button @click.prevent="mostrarOcultarBloque">{{ mostrarBloque ? '(-) Menos información' : '(+) Más información' }}</button>
            <div v-if="mostrarBloque" class="mb-3">
              <div class="mb-3" v-if="btnEditar">
                <div class="row">
                  <div class="col-2">
                    <label for="idEmpresa" class="form-label">IdEmpresa</label>
                  </div>
                  <div class="col-4">
                    <input type="text" class="form-control" id="idEmpresa" name="idEmpresa"
                      v-model="datoAsiento.idEmpresa" style='text-transform:uppercase' disabled>
                  </div>
                  <div class="col-2">
                    <label for="idAsiento" class="form-label">IdAsiento</label>
                  </div>
                  <div class="col-4">
                    <input type="text" class="form-control" id="idAsiento" name="idAsiento"
                      v-model="datoAsiento.idAsiento" disabled>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idUsuarioReg" class="form-label">IdUsuarioReg</label>
                  </div>
                  <div class="col-4">
                    <input type="text" class="form-control" id="idUsuarioReg" name="idUsuarioReg"
                      v-model="datoAsiento.idUsuarioReg" style='text-transform:uppercase' disabled>
                  </div>
                  <div class="col-2">
                    <label for="fechaReg" class="form-label">FechaReg</label>
                  </div>
                  <div class="col-4">
                    <input type="date" class="form-control" id="fechaReg" name="fechaReg" v-model="datoAsiento.fechaReg"
                     disabled>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idUsuarioAct" class="form-label">IdUsuarioAct</label>
                  </div>
                  <div class="col-4">
                    <input type="text" class="form-control" id="idUsuarioAct" name="idUsuarioAct"
                      v-model="datoAsiento.idUsuarioAct" style='text-transform:uppercase' disabled>
                  </div>
                  <div class="col-2">
                    <label for="fechaAct" class="form-label">FechaAct</label>
                  </div>
                  <div class="col-4">
                    <input type="date" class="form-control" id="fechaAct" name="fechaAct" v-model="datoAsiento.fechaAct"
                    disabled>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
        <div class="modal-footer">
          <button type="submit" class="btn btn-light" @click.prevent="guardarAsiento" v-if="btnCrear" title="Guardar">
            <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
          </button>
          <button type="submit" class="btn btn-light" @click.prevent="guardarEditAsiento" v-if="btnEditar"
            title="Actualizar">
            <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
          </button>
        </div>
      </div>
    </div>

    <!-- Details -->
    <hr>
    <div class="mb-3">
      <table class="tablaBusqueda">
        <tr>
<!--           <td><label for="nombre" class="form-label">Nombre</label></td>
          <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda"
              style="width: 500px; text-transform:uppercase;" required></td>
          <td>
            <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Buscar registros">
              <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
            </button>
          </td>
          <td>
            <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)"
              title="Todos los registros">
              <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
            </button>
          </td> -->
          <td>
            <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal"
              @click="abrirModalCrear" title="Nuevo registro">
              <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              Nuevo Registro
            </button>
          </td>
        </tr>
      </table>
    </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
<!--           <th scope="col"></th> -->
         <!--  <th scope="col">IdAsientoDet</th>
          <th scope="col">IdAsiento</th> -->
          <th scope="col">Código</th>
          <th scope="col">Nombre</th>
          <!-- <th scope="col">IdCuenta</th> -->
          <th scope="col">Referencia</th>
          <th scope="col" style="text-align: right;">Débito</th>
          <th scope="col" style="text-align: right;">Crédito</th>
<!--           <th scope="col">Estado</th> -->
<!--           <th scope="col">AsientoFechaReg</th> -->
        </tr>
      </thead>
      <tbody>
        <tr v-for="asientodet in datosPaginados" :key="asientodet.idAsientoDet">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;"
              @click="abrirModalEditar(asientodet.idAsientoDet)" title="Editar">edit_square</i></td>
<!--           <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;"
              @click="abrirEditar(asientodet.idAsientoDet)" title="Editar">edit_square</i></td> -->
          <!-- <td>{{ asientodet.idAsientoDet }}</td>
          <td>{{ asientodet.idAsiento }}</td> -->
          <td>{{asientodet.codigoCuenta}}</td>
          <td>{{asientodet.nombreCuenta}}</td>
          <!-- <td>{{asientodet.idCuenta }}</td> -->
          <td>{{asientodet.referencia }}</td>
          <td style="text-align: right;">{{ asientodet.debito }}</td>
          <td style="text-align: right;">{{ asientodet.credito }}</td>
<!--           <td>{{ asientodet.estado }}</td> -->
<!--           <td>{{ getFormattedDate(asientodet.asientoFechaReg, 'DD/MM/YYYY') }}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;"
              @click="deleteAsiento(asientodet.idAsientoDet)" title="Borrar">delete</i></td> -->
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <th colspan="4" style="text-align: right;">Total:</th>
          <td style="text-align: right;">{{ sumaDebito }}</td>
          <td style="text-align: right;">{{ sumaCredito }}</td>
        </tr>
      </tfoot>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click="getDataPaginaTodos(pagina)"
          class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{ pagina }}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
    <!-- Modal -->
    <div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true"
      v-if="modalWindow">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title" id="exampleModalLabel">
              <i class="fa fa-user-plus"></i> {{ titulo }}
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
            </button>
          </div>
          <form>
            <div class="modal-body">
              <div class="mb-3" v-if="btnEditar_det">
                <div class="row">
                  <div class="col-2">
                    <label for="idAsientoDet" class="form-label">IdAsientoDet</label>
                  </div>
                  <div class="col-10">
                    <input type="text" class="form-control" id="idAsientoDet" name="idAsientoDet"
                      v-model="datoAsientoDet.idAsientoDet" disabled>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idAsiento" class="form-label">IdAsiento</label>
                  </div>
                  <div class="col-10">
                    <input type="text" class="form-control" id="idAsiento" name="idAsiento"
                      v-model="datoAsientoDet.idAsiento" style='text-transform:uppercase' required>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <!-- Botón Lista de Valores -->
                <div class="row">
                  <div class="col-2">
                    <label for="idCuenta" class="form-label"> Cuenta</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idCuenta" name="idCuenta" v-model="datoAsientoDet.idCuenta">
                      <option v-for="cuenta in cuentas" :value="cuenta.idCuenta" :key="cuenta.idCuenta">
                        {{ cuenta.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
                <!-- Botón Lista de Valores -->
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="debito" class="form-label">Débito</label>
                  </div>
                  <div class="col-10">
                    <input type="text" class="form-control" id="debito" name="debito" v-model="datoAsientoDet.debito"
                      style='text-transform:uppercase' required>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="credito" class="form-label">Crédito</label>
                  </div>
                  <div class="col-10">
                    <input type="text" class="form-control" id="credito" name="credito" v-model="datoAsientoDet.credito"
                      style='text-transform:uppercase' required>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="referencia" class="form-label">Referencia</label>
                  </div>
                  <div class="col-10">
                    <textarea class="form-control" id="referencia" name="referencia" v-model="datoAsientoDet.referencia"
                      style='text-transform:uppercase'></textarea>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="modal-footer">
<!--
            <div class="me-auto">
              <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
                <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
              </button>
            </div>
-->            <button type="submit" class="btn btn-light" @click.prevent="guardarAsientoDet" v-if="btnCrear_det"
              title="Guardar">
              <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
            </button>
            <button type="submit" class="btn btn-light" @click.prevent="guardarEditAsientoDet" v-if="btnEditar_det"
              title="Actualizar">
              <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Details -->

    <Footer />
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import { validarForm } from '@/modules/validacionesForms.js';
import dateFormat from '@/modules/dateFormat.js';
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from 'sweetalert'
export default {
  components: {
    Layout, Footer
  },
  data() {
    return {
      // Variables master
      asientos: [],
      datoAsiento: {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      p_idAsiento: '',
      // Variables master
      // Variables details
      asientodets: [],
      datoAsientoDet: {},
      nombreBusqueda_det: '',
      titulo_det: '',
      btnCrear_det: false,
      btnEditar_det: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      cuentas: [],
      mostrarBloque: false,
      modalWindow: true
      // Variables details
    }
  },
  computed: {
    sumaDebito() {
      return this.datosPaginados.reduce((acc, cur) => acc + cur.debito, 0);
    },
    sumaCredito() {
      return this.datosPaginados.reduce((acc, cur) => acc + cur.credito, 0);
    }
  },
  mounted() {
    this.p_idAsiento = this.$route.params.p_idasiento
    this.abrirEditar(this.p_idAsiento)
    this.getDataPaginaTodos(this.paginaActual)
  },
  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    mostrarOcultarBloque() {
      this.mostrarBloque = !this.mostrarBloque;
    },
    // Procedimientos master
    validarForm() {
      const requiredFields = [
        'descripcion'
        , 'estadoAsiento'
      ];
      const requiredFieldsText = [
        'idEmpresa'
        , 'descripcion'
        , 'estadoAsiento'
      ];
      return validarForm(this.datoAsiento, requiredFields, requiredFieldsText);
    },
    async guardarAsiento() {
      if (this.validarForm() === 1) {
        try {
          this.datoAsiento.idEmpresa = window.sessionStorage.getItem("idEmpresa");
          await api.post('/asientos', this.datoAsiento)
          swal("Correcto!", "Asiento creada exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditAsiento() {
      if (this.validarForm() === 1) {
        try {
          await api.post('/asientos', this.datoAsiento)
          swal("Correcto!", "Asiento creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirCrear() {
      this.modalWindow = true
      this.datoAsiento = {}
      this.titulo = 'Crear Asiento'
      this.btnCrear = true
      this.btnEditar = false
    },
    abrirEditar(idAsiento) {
      this.modalWindow = true
      if (idAsiento != null) {
        api.get('/vwasientos/' + idAsiento).then(resp => {
          this.datoAsiento = resp.data;
        });
      }
      this.titulo = 'Editar Asiento'
      this.btnCrear = false
      this.btnEditar = true
    },
    cerrarAsiento() {
      this.$router.push('/Asiento')
    },
    // Procedimientos master
    // Procedimientos detalle
    totalPaginas() {
      return Math.ceil(this.asientodets.length / this.elementosPorPagina)
    },
/*     getDataPagina(noPagina) {
      if (this.nombreBusqueda != '') {
        api.get('/vwasientodets/nombre/' + this.nombreBusqueda).then(response => {
          this.asientodets = response.data.reverse();
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.asientodets.slice(ini, fin);
        });
      }
    }, */
    getDataPaginaTodos(noPagina) {
      api.get('/vwasientodets/idasiento/'+this.p_idAsiento).then(response => {
        this.asientodets = response.data.reverse();
        this.paginaActual = noPagina;
        this.datosPaginados = [];
        let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
        let fin = (noPagina * this.elementosPorPagina);
        this.datosPaginados = this.asientodets.slice(ini, fin);
      });
    },
    getPreviousPage() {
      if (this.paginaActual > 1) {
        this.paginaActual--;
      }
      this.getDataPaginaTodos(this.paginaActual);
    },
    getNextPage() {
      if (this.paginaActual < this.totalPaginas()) {
        this.paginaActual++;
      }
      this.getDataPaginaTodos(this.paginaActual);
    },
    isActive(noPagina) {
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarFormDet() {
      const requiredFields = [
        'descripcion'
        , 'estadoAsiento'
      ];
      const requiredFieldsText = [
        'idEmpresa'
        , 'descripcion'
        , 'estadoAsiento'
      ];
      return validarForm(this.datoAsiento, requiredFields, requiredFieldsText);
    },
    async guardarAsientoDet() {
      if (this.validarForm() === 1) {
        try {
          this.datoAsientoDet.idAsiento = this.datoAsiento.idAsiento;
          await api.post('/asientodets', this.datoAsientoDet)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "AsientoDet creada exitosamente!", "success");
          this.getDataPaginaTodos(this.paginaActual);
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditAsientoDet() {
      if (this.validarForm() === 1) {
        try {
          await api.post('/asientodets', this.datoAsientoDet)
          $('#ventanaModal').modal('hide');
          this.getDataPaginaTodos(this.paginaActual);
          swal("Correcto!", "AsientoDet creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear() {
      this.modalWindow = true
      this.datoAsientoDet = {}
      this.titulo = 'Crear Asiento'
      this.btnCrear_det = true
      this.btnEditar_det = false
    },
    abrirModalEditar(idAsientoDet) {
      this.modalWindow = true
      if (idAsientoDet != null) {
        api.get('/vwasientodets/' + idAsientoDet).then(resp => {
          this.datoAsientoDet = resp.data;
        });
      }
      $('#ventanaModal').modal('show');
      this.titulo = 'Editar Asiento'
      this.btnCrear_det = false
      this.btnEditar_det = true
    },
    abrirEditarDet(idAsientoDet) {
      this.modalWindow = true
      if (idAsientoDet != null) {
        this.$router.push('/asientodetmd/' + idAsientoDet)
      }
    },
    async deleteAsientoDet(idAsientoDet) {
      try {
        await api.delete('/asientodets/' + idAsientoDet)
        this.getDataPaginaTodos(this.paginaActual);
      } catch (error) {
        alert('No se pudo eliminar')
      }
    },
    // Procedimientos detalle
    fetchCuentas() {
      fetch('http://localhost:8080/api/v1/cuentas')
        .then(response => response.json())
        .then(data => {
          this.cuentas = data;
        })
        .catch(error => {
          console.error('Error fetching cuentas:', error);
        });
    },
  },
}
</script>
